import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5cce9768&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=5cce9768&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cce9768",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BookOpen: require('/vercel/path0/components/icons/BookOpen.vue').default,AppLink: require('/vercel/path0/components/general/AppLink.vue').default,Card: require('/vercel/path0/components/general/Card.vue').default})
